/* unplugin-vue-components disabled */import { render } from "./Product.vue?vue&type=template&id=068f8f10&scoped=true&ts=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=068f8f10&scoped=true&lang=scss"
import "./Product.vue?vue&type=style&index=1&id=068f8f10&lang=scss"
import "./Product.vue?vue&type=style&index=2&id=068f8f10&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068f8f10"]])

export default __exports__